import M360MarkdownLink from "@/lib/M360MarkdownLink";
import { normalizeChatDisplayText } from "../../normalizeChatDisplayText";
import type { FacilityLocationDisplay } from "../cardDisplayUtils";

type CardFacilityLocationLineProps = FacilityLocationDisplay;

export function CardFacilityLocationLine({
  facilityName,
  facilityHref,
  location,
  fallbackSubtitle
}: CardFacilityLocationLineProps) {
  if (facilityHref) {
    const label = facilityName?.trim() || "Facility";
    return (
      <p className="text-body-small text-sys-brand-on-surface-variant">
        <M360MarkdownLink
          href={facilityHref}
          className="font-medium text-sys-brand-primary no-underline hover:underline"
        >
          {normalizeChatDisplayText(label)}
        </M360MarkdownLink>
        {location ? <span>{` · ${normalizeChatDisplayText(location)}`}</span> : null}
      </p>
    );
  }

  const plainText = [facilityName, location].filter(Boolean).join(" · ") || fallbackSubtitle;
  if (!plainText) {
    return null;
  }

  return <p className="text-body-small text-sys-brand-on-surface-variant">{normalizeChatDisplayText(plainText)}</p>;
}
